import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString($props.title), 1 /* TEXT */),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close'))),
            class: "modal-close"
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("v-if", true)
}